import UdeskLocales from 'UdeskLocales';
import React, { FC, memo, useMemo } from 'react';
import { useOptions } from './hooks';
import { Select } from 'udesk-ui';
import { SelectProps } from 'antd';
import { isNil } from 'lodash-es';

interface TemplateProps extends SelectProps<number | number[]> {
    hasAll?: boolean;
    disabledList?: number[];
    disabledAllListWithoutChecked?: boolean;
    overrideList?: number[];
}

const Template: FC<TemplateProps> = memo((props) => {
    const {
        hasAll,
        disabledList,
        disabledAllListWithoutChecked,
        overrideList,
        style,
        value: _value,
        options: _options,
        ...restProps
    } = props;

    const _style = useMemo(() => {
        return {
            width: 200,
            ...style,
        };
    }, [style]);

    const { value, checkedList } = useMemo(() => {
        if (isNil(_value)) {
            return { value: _value, checkedList: [] };
        } else if (Array.isArray(_value)) {
            return { value: _value.map(Number), checkedList: _value.map(Number) };
        } else {
            return {
                value: Number(_value),
                checkedList: [Number(_value)],
            };
        }
    }, [_value]);

    const { options } = useOptions({
        hasAll,
        disabledList,
        disabledAllListWithoutChecked,
        checkedList,
        overrideList,
        options: _options,
    });

    return (
        <Select
            placeholder={
                /* 请选择语言 */ UdeskLocales['current'].components.languageSelect.index
                    .pleaseSelectLanguage
            }
            value={value}
            style={_style}
            options={options}
            {...restProps}
        />
    );
});

export default Template;
